import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Button,
  Container,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody
} from 'reactstrap';
import Handler from '../Helpers/Handler';
import Logo from '../Assets/images/logo.png';
import { deleteAllCookies } from '../Helpers/Utils';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggle = () => setIsOpen(!isOpen);

  // 1st Image-la irukka mari active link-ku kitta mattum color maarum
  const isActive = (path) => location.pathname === path ? "active-link" : "";

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const handleLogout = () => {
    deleteAllCookies();
    window.location.href = "/";
  };

  const menuItems = [
    { name: 'Dashboard', path: '/dashboard' },
    { name: 'My Products', path: '/products' },
    { name: 'My Categories', path: '/category' },
    { name: 'My Orders', path: '/orders' },
    { name: 'QR Codes', path: '/qrcodes' },
    { name: 'Customers', path: '/customers' },
  ];

  return (
    <header className="main-header border-bottom bg-white py-3">
      <Container>
        <div className="d-flex justify-content-between align-items-center">
          
          {/* LOGO - Exact like 1st image */}
          <Link to="/">
            <img className="header-logo" src={Logo} alt="logo" style={{ height: '45px' }} />
          </Link>

          {/* DESKTOP MENU - Clean & No Icons (Like Image 1) */}
          <ul className="d-none d-lg-flex align-items-center mb-0 gap-4 list-unstyled">
            {menuItems.map((item, index) => (
              <li key={index}>
                <Link 
                  to={item.path} 
                  className={`text-decoration-none nav-text ${isActive(item.path)}`}
                  style={{ color: '#333', fontWeight: '500', fontSize: '15px' }}
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>

          {/* LOGOUT - Minimalist button style */}
          <div className="d-flex align-items-center gap-3">
            <Button
              className="d-none d-lg-block border-0 px-4"
              style={{ backgroundColor: '#c81010', borderRadius: '5px' }}
              onClick={handleLogout}
            >
              Logout
            </Button>

            {/* MOBILE MENU TOGGLE - Only shows on small screens */}
            <button className="btn d-lg-none border-0 p-0" onClick={toggle}>
               <span style={{ fontSize: '24px' }}>☰</span>
            </button>
          </div>
        </div>
      </Container>

      {/* MOBILE OFFCANVAS - Professional layout */}
      <Offcanvas isOpen={isOpen} toggle={toggle} direction="end">
        <OffcanvasHeader toggle={toggle} className="border-bottom">
          <img src={Logo} alt="logo" style={{ height: '35px' }} />
        </OffcanvasHeader>
        <OffcanvasBody>
          <ul className="list-unstyled">
            {menuItems.map((item, index) => (
              <li key={index} className="py-3 border-bottom">
                <Link 
                  to={item.path} 
                  onClick={toggle} 
                  className="text-decoration-none text-dark d-block w-100"
                  style={{ fontWeight: '500' }}
                >
                  {item.name}
                </Link>
              </li>
            ))}
            <li className="mt-4">
              <Button color="danger" className="w-100" onClick={handleLogout}>
                Logout
              </Button>
            </li>
          </ul>
        </OffcanvasBody>
      </Offcanvas>

      {/* Style Section - Active link highlight panna */}
      <style>
        {`
          .nav-text:hover { color: #007bff !important; }
          .active-link { color: #007bff !important; }
          .main-header { position: sticky; top: 0; z-index: 1000; }
        `}
      </style>
    </header>
  );
};

export default Header;